import MessageBoard from './MessageBoard'

export default MessageBoard
